import { render, staticRenderFns } from "./RetouchersOrderFuncBasedNewProstoy.vue?vue&type=template&id=7c5ad8e9&"
import script from "./RetouchersOrderFuncBasedNewProstoy.vue?vue&type=script&lang=js&"
export * from "./RetouchersOrderFuncBasedNewProstoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports